export default function returnDiscount({ cost, discount, discountType }) {
    try {
        if (discountType === 'flat') {
            return Number(discount)
        } else {
            let newDiscount = cost * (discount / 100)
            return Number(newDiscount)
        }
    } catch (error) {
        throw error
    }
}